import { render } from "./GroupCardMessage.vue?vue&type=template&id=6a604546"
import script from "./GroupCardMessage.vue?vue&type=script&lang=js"
export * from "./GroupCardMessage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\a\\WebApp\\FAOU.App\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__